(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zenlab-room-experience-v10"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-zlr10-root]').forEach((root) => {
      const video = root.querySelector('.zlr10-hero__video');
      const videoControl = root.querySelector('[data-zlr10-video-control]');
      const videoLabel = root.querySelector('[data-zlr10-video-label]');

      if (video && videoControl && videoLabel) {
        video.play().catch(() => {
          videoControl.setAttribute('aria-pressed', 'true');
          videoLabel.textContent = 'Play film';
        });

        videoControl.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(() => {});
            videoControl.setAttribute('aria-pressed', 'false');
            videoLabel.textContent = 'Pause film';
          } else {
            video.pause();
            videoControl.setAttribute('aria-pressed', 'true');
            videoLabel.textContent = 'Play film';
          }
        });
      }

      root.querySelectorAll('[data-zlr10-tabs]').forEach((group) => {
        const tabs = Array.from(group.querySelectorAll('[data-zlr10-tab]'));
        const panels = Array.from(group.querySelectorAll('[data-zlr10-panel]'));

        const activate = (tab, focus) => {
          const key = tab.dataset.zlr10Tab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.zlr10Panel !== key;
          });
          if (focus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab, false));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const next = (index + direction + tabs.length) % tabs.length;
            activate(tabs[next], true);
          });
        });
      });

      const explorer = root.querySelector('[data-zlr-explorer]');
      if (explorer) {
        explorer.classList.add('is-ready');
        const tabs = Array.from(explorer.querySelectorAll('[data-zlr-explorer-tab]'));
        const panels = Array.from(explorer.querySelectorAll('[data-zlr-explorer-panel]'));
        const descriptions = Array.from(explorer.querySelectorAll('[data-zlr-explorer-description]'));
        const status = explorer.querySelector('[data-zlr-explorer-status]');
        const modelTab = explorer.querySelector('[data-zlr-explorer-tab="model"]');

        const activateExplorer = (tab, focus) => {
          const key = tab.dataset.zlrExplorerTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
            const state = item.querySelector('[data-zlr-explorer-tab-state]');
            if (state) state.textContent = selected ? 'Showing' : 'View';
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.zlrExplorerPanel !== key;
          });
          descriptions.forEach((description) => {
            description.hidden = description.dataset.zlrExplorerDescription !== key;
          });
          if (status) status.textContent = `${tab.textContent.trim()} view selected.`;
          if (focus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateExplorer(tab, false));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const visibleTabs = tabs.filter((item) => !item.hidden);
            const current = visibleTabs.indexOf(tab);
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const next = (current + direction + visibleTabs.length) % visibleTabs.length;
            activateExplorer(visibleTabs[next], true);
          });
        });

        if (modelTab && window.customElements) {
          window.customElements.whenDefined('model-viewer').then(() => {
            modelTab.hidden = false;
          });
        }

        const reset = explorer.querySelector('[data-zlr-model-reset]');
        const reviewModel = explorer.querySelector('[data-zlr-review-model]');
        if (reset && reviewModel) {
          reset.addEventListener('click', () => {
            reviewModel.cameraOrbit = reviewModel.dataset.defaultOrbit;
            reviewModel.fieldOfView = reviewModel.dataset.defaultFieldOfView;
            if (status) status.textContent = 'Three-dimensional view reset.';
          });
        }
      }

      const chapters = Array.from(root.querySelectorAll('[data-zlr10-chapter]'));
      const navLinks = Array.from(root.querySelectorAll('[data-zlr10-nav]'));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          const key = visible.target.dataset.zlr10Chapter;
          navLinks.forEach((link) => {
            if (link.dataset.zlr10Nav === key) {
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        }, { rootMargin: '-22% 0px -60%', threshold: [0.05, 0.25, 0.5] });
        chapters.forEach((chapter) => observer.observe(chapter));
      }

      const form = root.querySelector('[data-zlr10-review-form]');
      const formStatus = root.querySelector('[data-zlr10-form-status]');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          if (formStatus) formStatus.textContent = 'Review state only — no information was sent.';
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenlab-room-experience-v8"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-zlr8-root]');

    const activateTabs = (scope, tabSelector, panelSelector, keyAttribute) => {
      const tabs = Array.from(scope.querySelectorAll(tabSelector));
      const panels = Array.from(scope.querySelectorAll(panelSelector));
      if (!tabs.length || !panels.length) return;

      const activate = (tab, focus = false) => {
        const key = tab.getAttribute(keyAttribute);
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.getAttribute(keyAttribute.replace('tab', 'panel')) !== key;
        });
        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          activate(tabs[nextIndex], true);
        });
      });
    };

    roots.forEach((root) => {
      root.querySelectorAll('[data-zlr8-tabs]').forEach((tabs) => {
        activateTabs(tabs, '[data-zlr8-tab]', '[data-zlr8-panel]', 'data-zlr8-tab');
      });

      const makerScope = root.querySelector('[data-zlr8-makers]');
      if (makerScope) {
        activateTabs(makerScope, '[data-zlr8-maker-tab]', '[data-zlr8-maker-panel]', 'data-zlr8-maker-tab');
      }

      const explorer = root.querySelector('[data-zlr-explorer]');
      if (explorer) {
        const tabs = Array.from(explorer.querySelectorAll('[data-zlr-explorer-tab]'));
        const panels = Array.from(explorer.querySelectorAll('[data-zlr-explorer-panel]'));
        const modelTab = explorer.querySelector('[data-zlr-explorer-tab="model"]');

        const activateExplorer = (tab, focus = false) => {
          const key = tab.dataset.zlrExplorerTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.zlrExplorerPanel !== key;
          });
          if (focus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateExplorer(tab));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const visibleTabs = tabs.filter((item) => !item.hidden);
            const visibleIndex = visibleTabs.indexOf(tab);
            let nextIndex = visibleIndex;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = visibleTabs.length - 1;
            if (event.key === 'ArrowRight') nextIndex = (visibleIndex + 1) % visibleTabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (visibleIndex - 1 + visibleTabs.length) % visibleTabs.length;
            activateExplorer(visibleTabs[nextIndex], true);
          });
        });

        if (modelTab && window.customElements) {
          window.customElements.whenDefined('model-viewer').then(() => {
            modelTab.hidden = false;
          });
        }

        const reset = explorer.querySelector('[data-zlr-model-reset]');
        const model = explorer.querySelector('model-viewer');
        if (reset && model) {
          reset.addEventListener('click', () => {
            model.cameraOrbit = model.dataset.defaultOrbit || '35deg 68deg auto';
            model.fieldOfView = model.dataset.defaultFieldOfView || '34deg';
          });
        }
      }

      const video = root.querySelector('.zlr8-hero__video');
      const videoControl = root.querySelector('[data-zlr8-video-control]');
      const videoLabel = root.querySelector('[data-zlr8-video-label]');
      if (video && videoControl) {
        const setVideoState = (playing) => {
          videoControl.setAttribute('aria-pressed', playing ? 'false' : 'true');
          if (videoLabel) videoLabel.textContent = playing ? 'Pause film' : 'Play film';
        };

        const startVideo = () => {
          const promise = video.play();
          if (promise) {
            promise.then(() => setVideoState(true)).catch(() => setVideoState(false));
          }
        };

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) startVideo();

        videoControl.addEventListener('click', () => {
          if (video.paused) {
            startVideo();
          } else {
            video.pause();
            setVideoState(false);
          }
        });
      }

      const navLinks = Array.from(root.querySelectorAll('[data-zlr8-nav]'));
      const chapters = Array.from(root.querySelectorAll('[data-zlr8-chapter]'));
      navLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      });
      if ('IntersectionObserver' in window && navLinks.length && chapters.length) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          const key = visible.target.dataset.zlr8Chapter;
          navLinks.forEach((link) => {
            if (link.dataset.zlr8Nav === key) {
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        }, { rootMargin: '-20% 0px -60%', threshold: [0.05, 0.25, 0.5] });
        chapters.forEach((chapter) => observer.observe(chapter));
      }

      const form = root.querySelector('[data-zlr8-review-form]');
      const formStatus = root.querySelector('[data-zlr8-form-status]');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          if (formStatus) formStatus.textContent = 'Review state only — no information was sent.';
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenlab-room-experience"]) return;
  try {
    
  const initZenlabRoom = (root) => {
    if (root.dataset.zenlabRoomReady === 'true') return;
    root.dataset.zenlabRoomReady = 'true';
    const lifecycle = new AbortController();
    const { signal } = lifecycle;
    const observers = [];
    root.zenlabRoomLifecycle = lifecycle;
    root.zenlabRoomObservers = observers;

    const globalHeader = document.querySelector('.shopify-section-group-header-group .site-header')
      || document.querySelector('.site-header');
    const orderRail = root.querySelector('[data-zlr-order-rail]');
    const hero = root.querySelector('[data-zlr-section="hero"]');
    const orderSection = root.querySelector('.zlr8-enquiry');
    const orderHeading = orderSection?.querySelector('h2');
    let railFrame = 0;
    const syncAnchorOffset = () => {
      const headerRect = globalHeader?.getBoundingClientRect();
      const headerBottom = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
      const rootRect = root.getBoundingClientRect();
      const heroRect = hero?.getBoundingClientRect();
      const orderRect = orderSection?.getBoundingClientRect();
      const orderEntryRect = orderHeading?.getBoundingClientRect() || orderRect;
      const formVisible = orderRect && orderEntryRect && orderEntryRect.top < window.innerHeight && orderRect.bottom > headerBottom;
      const inStory = heroRect && heroRect.bottom <= headerBottom && rootRect.bottom > headerBottom;
      const railFocused = orderRail?.contains(document.activeElement);
      if (orderRail) {
        orderRail.hidden = !((inStory && !formVisible) || railFocused);
        root.style.setProperty('--zlr-header-offset', `${Math.ceil(headerBottom)}px`);
        root.style.setProperty('--zlr-rail-left', `${Math.max(0, rootRect.left)}px`);
        root.style.setProperty('--zlr-rail-width', `${rootRect.width}px`);
      }
      const railHeight = orderRail?.getBoundingClientRect().height || 58;
      root.style.setProperty('--zlr-anchor-offset', `${Math.ceil(headerBottom + railHeight + 16)}px`);
    };
    const scheduleRail = () => {
      if (railFrame) return;
      railFrame = requestAnimationFrame(() => {
        railFrame = 0;
        syncAnchorOffset();
      });
    };
    syncAnchorOffset();
    window.addEventListener('resize', scheduleRail, { signal });
    window.addEventListener('scroll', scheduleRail, { signal, passive: true });
    orderRail?.addEventListener('focusout', scheduleRail, { signal });
    signal.addEventListener('abort', () => cancelAnimationFrame(railFrame), { once: true });
    if ('IntersectionObserver' in window) {
      const railObserver = new IntersectionObserver(scheduleRail);
      if (hero) railObserver.observe(hero);
      if (orderSection) railObserver.observe(orderSection);
      observers.push(railObserver);
    }
    if (globalHeader && 'ResizeObserver' in window) {
      const headerObserver = new ResizeObserver(scheduleRail);
      headerObserver.observe(globalHeader);
      headerObserver.observe(root);
      observers.push(headerObserver);
    }

    const formStatus = root.querySelector('.zlr8-form__status[tabindex="-1"]:not([hidden])');
    if (formStatus) formStatus.focus();

    const proofSlider = root.querySelector('.zlr8-proof-slider');
    if (proofSlider) {
      const rail = proofSlider.querySelector('.zlr8-proof');
      const slides = Array.from(rail?.children || []);
      const controls = proofSlider.querySelector('.zlr8-proof-controls');
      const previous = proofSlider.querySelector('[data-zlr-proof-prev]');
      const next = proofSlider.querySelector('[data-zlr-proof-next]');
      const status = proofSlider.querySelector('[data-zlr-proof-status]');
      const dots = Array.from(proofSlider.querySelectorAll('[data-zlr-proof-dot]'));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let settleTimer = 0;
      let resizeFrame = 0;
      if (rail && controls && previous && next && status && slides.length > 1) {
        proofSlider.classList.add('is-enhanced');
        controls.hidden = false;
        const syncControls = () => {
          previous.setAttribute('aria-disabled', String(index === 0));
          next.setAttribute('aria-disabled', String(index === slides.length - 1));
          status.textContent = (index + 1) + ' / ' + slides.length;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
          slides.forEach((slide, i) => slide.toggleAttribute('data-zlr-proof-active', i === index));
        };
        const centreOffset = (slide) => {
          const card = slide.getBoundingClientRect();
          const viewport = rail.getBoundingClientRect();
          return card.left + card.width / 2 - viewport.left - viewport.width / 2;
        };
        const slidePosition = (i) => rail.scrollLeft + centreOffset(slides[i]);
        const go = (i, immediate = false) => {
          index = Math.max(0, Math.min(slides.length - 1, i));
          clearTimeout(settleTimer);
          rail.scrollTo({ left: slidePosition(index), behavior: immediate || reduced.matches || navigator.connection?.saveData ? 'instant' : 'smooth' });
          syncControls();
        };
        let mouseDrag = null;
        let suppressDragClick = false;
        const endMouseDrag = () => {
          if (!mouseDrag) return;
          const drag = mouseDrag;
          mouseDrag = null;
          rail.classList.remove('is-mouse-dragging');
          if (rail.hasPointerCapture(drag.id)) rail.releasePointerCapture(drag.id);
          if (drag.moved) {
            suppressDragClick = true;
            const nearest = slides.reduce((best, slide, i) => Math.abs(centreOffset(slide)) < Math.abs(centreOffset(slides[best])) ? i : best, 0);
            go(nearest);
          }
        };
        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || !event.target.closest('.zlr8-proof__image')) return;
          suppressDragClick = false;
          mouseDrag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, moved: false };
          rail.setPointerCapture(event.pointerId);
        }, { signal });
        rail.addEventListener('pointermove', (event) => {
          if (!mouseDrag || event.pointerId !== mouseDrag.id) return;
          const dx = event.clientX - mouseDrag.x;
          const dy = event.clientY - mouseDrag.y;
          if (!mouseDrag.moved) {
            if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
            if (Math.abs(dy) >= Math.abs(dx)) { endMouseDrag(); return; }
            mouseDrag.moved = true;
            rail.classList.add('is-mouse-dragging');
          }
          event.preventDefault();
          rail.scrollLeft = mouseDrag.left - dx;
        }, { signal });
        rail.addEventListener('pointerup', endMouseDrag, { signal });
        rail.addEventListener('pointercancel', endMouseDrag, { signal });
        rail.addEventListener('lostpointercapture', endMouseDrag, { signal });
        rail.addEventListener('dragstart', (event) => {
          if (event.target.closest('.zlr8-proof__image')) event.preventDefault();
        }, { signal });
        rail.addEventListener('click', (event) => {
          if (!suppressDragClick) return;
          suppressDragClick = false;
          event.preventDefault();
          event.stopPropagation();
        }, { signal, capture: true });
        previous.addEventListener('click', () => { if (index > 0) go(index - 1); }, { signal });
        next.addEventListener('click', () => { if (index < slides.length - 1) go(index + 1); }, { signal });
        dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || event.altKey || event.ctrlKey || event.metaKey) return;
          const target = event.key === 'ArrowRight' ? index + 1 : event.key === 'ArrowLeft' ? index - 1
            : event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : null;
          if (target === null) return;
          event.preventDefault();
          go(target);
        }, { signal });
        rail.addEventListener('scroll', () => {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            index = slides.reduce((best, slide, i) => Math.abs(centreOffset(slide)) < Math.abs(centreOffset(slides[best])) ? i : best, 0);
            syncControls();
          }, 160);
        }, { signal, passive: true });
        if ('ResizeObserver' in window) {
          let previousWidth = rail.clientWidth;
          const observer = new ResizeObserver(() => {
            if (rail.clientWidth === previousWidth) return;
            previousWidth = rail.clientWidth;
            cancelAnimationFrame(resizeFrame);
            resizeFrame = requestAnimationFrame(() => go(index, true));
          });
          observer.observe(rail);
          observers.push(observer);
        }
        signal.addEventListener('abort', () => {
          if (mouseDrag && rail.hasPointerCapture(mouseDrag.id)) rail.releasePointerCapture(mouseDrag.id);
          mouseDrag = null;
          rail.classList.remove('is-mouse-dragging');
          clearTimeout(settleTimer);
          cancelAnimationFrame(resizeFrame);
          controls.hidden = true;
          proofSlider.classList.remove('is-enhanced');
          slides.forEach((slide) => slide.removeAttribute('data-zlr-proof-active'));
        }, { once: true });
        syncControls();
      }
    }

    const storyMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const storyDataSaving = Boolean(navigator.connection?.saveData);
    const storyAnimations = new Map();
    const animateStoryUnit = (element, duration = 360, distance = 8) => {
      if (!element?.animate || signal.aborted || storyMotionPreference.matches || storyDataSaving) return;
      storyAnimations.get(element)?.cancel();
      const animation = element.animate([
        { opacity: 0.86, transform: `translateY(${distance}px)` },
        { opacity: 1, transform: 'translateY(0)' },
      ], { duration, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      storyAnimations.set(element, animation);
      const forget = () => {
        if (storyAnimations.get(element) === animation) storyAnimations.delete(element);
      };
      animation.addEventListener('finish', forget, { once: true });
      animation.addEventListener('cancel', forget, { once: true });
    };
    const cancelStoryMotion = () => {
      storyAnimations.forEach((animation) => animation.cancel());
      storyAnimations.clear();
    };
    storyMotionPreference.addEventListener('change', () => {
      if (storyMotionPreference.matches) cancelStoryMotion();
    }, { signal });
    signal.addEventListener('abort', cancelStoryMotion, { once: true });
    document.addEventListener('shopify:block:select', cancelStoryMotion, { signal });
    if ('IntersectionObserver' in window && !storyMotionPreference.matches && !storyDataSaving) {
      const storyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.12) return;
          storyObserver.unobserve(entry.target);
          animateStoryUnit(entry.target);
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('.zlr8-scenes article, .zlr8-material, .zlr8-system, .zlr8-closing')
        .forEach((unit) => storyObserver.observe(unit));
      observers.push(storyObserver);
    }

    const explorer = root.querySelector('[data-zlr-explorer]');
    if (explorer) {
      const tabs = Array.from(explorer.querySelectorAll('[data-zlr-explorer-tab]'));
      const panels = Array.from(explorer.querySelectorAll('[data-zlr-explorer-panel]'));
      const descriptions = Array.from(explorer.querySelectorAll('[data-zlr-explorer-description]'));
      const status = explorer.querySelector('[data-zlr-explorer-status]');
      const visiblePosition = explorer.querySelector('[data-zlr-explorer-position]');
      const visibleName = explorer.querySelector('[data-zlr-explorer-active-name]');
      const tabsShell = explorer.querySelector('.zlr8-tabs-shell');
      const tabStrip = explorer.querySelector('.zlr8-tabs');
      const syncTabOverflow = () => {
        if (!tabStrip || !tabsShell) return;
        const maximum = Math.max(0, tabStrip.scrollWidth - tabStrip.clientWidth);
        const position = Math.max(0, Math.min(maximum, tabStrip.scrollLeft));
        tabsShell.classList.toggle('can-scroll-start', position > 2);
        tabsShell.classList.toggle('can-scroll-end', maximum - position > 2);
      };
      tabStrip?.addEventListener('scroll', syncTabOverflow, { signal, passive: true });
      let tabLayoutFrame = 0;
      let previousTabLayout = '';
      const syncTabLayout = () => {
        if (!tabStrip || signal.aborted) return;
        const layout = `${tabStrip.clientWidth}:${tabStrip.clientHeight}:${tabStrip.scrollWidth}`;
        if (layout !== previousTabLayout) {
          previousTabLayout = layout;
          const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
          const maximum = Math.max(0, tabStrip.scrollWidth - tabStrip.clientWidth);
          if (selected && maximum > 1) {
            const stripRect = tabStrip.getBoundingClientRect();
            const selectedRect = selected.getBoundingClientRect();
            const leftEdge = stripRect.left + 7;
            const rightEdge = stripRect.right - 7;
            const delta = selectedRect.left < leftEdge ? selectedRect.left - leftEdge
              : selectedRect.right > rightEdge ? selectedRect.right - rightEdge : 0;
            if (Math.abs(delta) > 1) {
              tabStrip.scrollLeft = Math.max(0, Math.min(maximum, tabStrip.scrollLeft + delta));
            }
          }
        }
        syncTabOverflow();
      };
      const scheduleTabLayout = () => {
        if (tabLayoutFrame || signal.aborted) return;
        tabLayoutFrame = requestAnimationFrame(() => {
          tabLayoutFrame = 0;
          syncTabLayout();
        });
      };
      window.addEventListener('resize', scheduleTabLayout, { signal });
      signal.addEventListener('abort', () => cancelAnimationFrame(tabLayoutFrame), { once: true });
      if (tabStrip && 'ResizeObserver' in window) {
        const tabsObserver = new ResizeObserver(scheduleTabLayout);
        tabsObserver.observe(tabStrip);
        tabs.forEach((tab) => tabsObserver.observe(tab));
        observers.push(tabsObserver);
      }
      explorer.querySelector('[data-zlr-view-prev]')?.addEventListener('click', () => {
        const index = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (index > 0) activateView(tabs[index - 1]);
      }, { signal });
      explorer.querySelector('[data-zlr-view-next]')?.addEventListener('click', () => {
        const index = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (index < tabs.length - 1) activateView(tabs[index + 1]);
      }, { signal });
      const activeLabel = root.dataset.zlrExplorerActiveLabel || 'Showing';
      const inactiveLabel = root.dataset.zlrExplorerInactiveLabel || 'View';
      const statusTemplate = root.dataset.zlrExplorerStatusTemplate || 'Showing %label%, %index% of %total%.';
      const statusFallback = root.dataset.zlrExplorerStatusFallback || 'Room view';

      const activateView = (tab, announce = true) => {
        const view = tab.dataset.zlrExplorerTab;
        const viewChanged = tab.getAttribute('aria-selected') !== 'true';
        const activeIndex = tabs.indexOf(tab);
        const label = tab.querySelector('.zlr-explorer__control-name')?.textContent?.trim() || statusFallback;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
          const stateLabel = item.querySelector('[data-zlr-explorer-tab-state]');
          if (stateLabel) stateLabel.textContent = selected ? activeLabel : inactiveLabel;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.zlrExplorerPanel !== view;
        });
        descriptions.forEach((description) => {
          description.hidden = description.dataset.zlrExplorerDescription !== view;
        });
        if (visiblePosition) {
          visiblePosition.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(tabs.length).padStart(2, '0')}`;
        }
        if (visibleName) visibleName.textContent = label;
        if (announce && tabStrip) {
          const stripRect = tabStrip.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          tabStrip.scrollLeft += tabRect.left - stripRect.left - (stripRect.width - tabRect.width) / 2;
        }
        const previousView = explorer.querySelector('[data-zlr-view-prev]');
        const nextView = explorer.querySelector('[data-zlr-view-next]');
        if (previousView) previousView.disabled = activeIndex === 0;
        if (nextView) nextView.disabled = activeIndex === tabs.length - 1;
        syncTabOverflow();
        if (announce && viewChanged) {
          const activePanel = panels.find((panel) => panel.dataset.zlrExplorerPanel === view);
          const activeDescription = descriptions.find((description) => description.dataset.zlrExplorerDescription === view);
          const activeImage = activePanel?.querySelector('img');
          if (activeImage?.complete && activeImage.naturalWidth > 0) {
            animateStoryUnit(activePanel, 200, 0);
            animateStoryUnit(activeDescription, 200, 0);
          }
        }
        if (announce && status) {
          status.textContent = statusTemplate
            .replace('%label%', label)
            .replace('%index%', String(tabs.indexOf(tab) + 1))
            .replace('%total%', String(tabs.length));
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateView(tab), { signal });
        tab.addEventListener('keydown', (event) => {
          const currentIndex = tabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === currentIndex) return;
          event.preventDefault();
          tabs[nextIndex].focus();
          activateView(tabs[nextIndex]);
        }, { signal });
      });

      root.addEventListener('shopify:block:select', (event) => {
        const selectedPanel = event.target.closest?.('[data-zlr-explorer-panel]');
        if (!selectedPanel || !explorer.contains(selectedPanel)) return;
        const tab = tabs.find((item) => item.dataset.zlrExplorerTab === selectedPanel.dataset.zlrExplorerPanel);
        if (tab) activateView(tab, false);
      }, { signal });

      const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      if (selectedTab) activateView(selectedTab, false);
      scheduleTabLayout();
    }

    const motionFrame = root.querySelector('.zlr-hero__media--motion');
    const ambientVideo = motionFrame?.querySelector('video');
    const motionControl = root.querySelector('[data-zlr-motion-control]');
    const motionLabel = motionControl?.querySelector('[data-zlr-motion-label]');
    if (ambientVideo && motionControl && motionLabel) {
      const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const dataSaving = Boolean(navigator.connection?.saveData);
      const playLabel = root.dataset.zlrMotionPlayLabel || 'Play ambient film';
      const pauseLabel = root.dataset.zlrMotionPauseLabel || 'Pause ambient film';
      const responsiveReviewLoop = ambientVideo.hasAttribute('data-zlr-review-loop')
        ? window.matchMedia('(max-width: 64rem)')
        : null;
      let pageReady = document.readyState === 'complete';
      let inView = false;
      let userPaused = false;

      let reviewFrameHandle = null;
      let presentedReviewTime = 0;
      const syncReviewLoopFocalPoint = () => {
        if (!responsiveReviewLoop || signal.aborted) return;
        const personInFrame = presentedReviewTime >= 17.6;
        ambientVideo.style.objectPosition = responsiveReviewLoop.matches && personInFrame ? '10% 52%' : '';
      };
      const onReviewVideoFrame = (_now, metadata) => {
        reviewFrameHandle = null;
        if (signal.aborted) return;
        presentedReviewTime = metadata.mediaTime;
        syncReviewLoopFocalPoint();
        reviewFrameHandle = ambientVideo.requestVideoFrameCallback(onReviewVideoFrame);
      };

      const setMotionState = (playing) => {
        motionLabel.textContent = playing ? pauseLabel : playLabel;
        motionControl.setAttribute('data-zlr-motion-state', playing ? 'playing' : 'paused');
        motionControl.setAttribute('aria-label', playing
          ? (root.dataset.zlrMotionPauseAccessible || pauseLabel)
          : (root.dataset.zlrMotionPlayAccessible || playLabel));
      };
      const attemptAmbientPlayback = () => {
        if (!pageReady || !inView || document.hidden || userPaused || motionPreference.matches || dataSaving) return;
        ambientVideo.play().catch(() => setMotionState(false));
      };

      setMotionState(!ambientVideo.paused);
      motionControl.hidden = motionPreference.matches || dataSaving;
      ambientVideo.addEventListener('playing', () => {
        motionFrame.classList.add('is-video-visible');
        setMotionState(true);
      }, { signal });
      if (responsiveReviewLoop && typeof ambientVideo.requestVideoFrameCallback === 'function'
        && typeof ambientVideo.cancelVideoFrameCallback === 'function') {
        reviewFrameHandle = ambientVideo.requestVideoFrameCallback(onReviewVideoFrame);
        responsiveReviewLoop.addEventListener('change', syncReviewLoopFocalPoint, { signal });
        signal.addEventListener('abort', () => {
          if (reviewFrameHandle !== null) ambientVideo.cancelVideoFrameCallback(reviewFrameHandle);
          reviewFrameHandle = null;
        }, { once: true });
      }
      ambientVideo.addEventListener('pause', () => setMotionState(false), { signal });
      ambientVideo.addEventListener('error', () => {
        motionFrame.classList.remove('is-video-visible');
        motionControl.hidden = true;
      }, { signal });
      motionControl.addEventListener('click', () => {
        if (!ambientVideo.paused) {
          userPaused = true;
          ambientVideo.pause();
          return;
        }
        userPaused = false;
        ambientVideo.play().catch(() => setMotionState(false));
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) ambientVideo.pause();
        else attemptAmbientPlayback();
      }, { signal });
      motionPreference.addEventListener('change', () => {
        motionControl.hidden = motionPreference.matches || dataSaving;
        if (motionPreference.matches) {
          ambientVideo.pause();
          motionFrame.classList.remove('is-video-visible');
        } else {
          attemptAmbientPlayback();
        }
      }, { signal });
      signal.addEventListener('abort', () => ambientVideo.pause(), { once: true });

      if (!pageReady) {
        window.addEventListener('load', () => {
          pageReady = true;
          attemptAmbientPlayback();
        }, { once: true, signal });
      }
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
          inView = Boolean(entries[0]?.isIntersecting && entries[0].intersectionRatio >= 0.25);
          if (inView) attemptAmbientPlayback();
          else ambientVideo.pause();
        }, { threshold: [0, 0.25] });
        videoObserver.observe(motionFrame);
        observers.push(videoObserver);
      }
    }
  };

  const rootsWithin = (target) => {
    const roots = Array.from(target.querySelectorAll?.('[data-zenlab-room]') || []);
    if (target.matches?.('[data-zenlab-room]')) roots.unshift(target);
    return roots;
  };

  document.querySelectorAll('[data-zenlab-room]').forEach(initZenlabRoom);
  document.addEventListener('shopify:block:select', (event) => {
    const selectedDetails = event.target.matches('details') ? event.target : event.target.closest('details');
    if (selectedDetails?.closest('[data-zenlab-room]')) selectedDetails.open = true;
  });
  document.addEventListener('shopify:section:load', (event) => {
    rootsWithin(event.target).forEach(initZenlabRoom);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    rootsWithin(event.target).forEach((root) => {
      root.zenlabRoomLifecycle?.abort();
      root.zenlabRoomObservers?.forEach((observer) => observer.disconnect());
      delete root.dataset.zenlabRoomReady;
      delete root.zenlabRoomLifecycle;
      delete root.zenlabRoomObservers;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
